// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { initialize } from 'redux-form'
import { AFS_GRID_FILTER } from 'redux/modules/interferenceAnalysis/constants'
import { AnalysisTypeIdEnum } from 'config/enums'
import { castToString } from 'helpers/reduxFormFunctions'

const initializeAFSGridFilter = (overrideValues = {}) => (dispatch, getState) => {
  // this should never be possible but because of the chain reaction that happens
  // with bandId, this messaging will call the error out!
  if (overrideValues.bandId === null || overrideValues.bandId === undefined) {
    throw new Error('Error: initializeAFSGridFilter was called but no bandId was given')
  }

  return dispatch(initialize(AFS_GRID_FILTER, {
    // these values define the query for the dataset to be displayed.
    // when these change, it will trigger updateAnalysisResults
    // which will take these values and hit the API for grid data
    analysisTypeId: castToString(AnalysisTypeIdEnum.ENVIRONMENT),
    applyResultFilter: false,
    bandId: null,

    // these values filter the displayed paths that are already stored in redux-form
    filterSelect: 'pathName',
    filterInput: '',

    // these are whatever values the user wants to persist through
    ...overrideValues,
  }))
}

export default initializeAFSGridFilter
